export const SIDEBAR_UPDATE = 'SIDEBAR_UPDATE';

export const updateSidebar = update => ({
  type: SIDEBAR_UPDATE,
  payload: update
});
